import { render, staticRenderFns } from "./ReviewsPagination.vue?vue&type=template&id=eaee21a4&scoped=true"
import script from "./ReviewsPagination.vue?vue&type=script&lang=js"
export * from "./ReviewsPagination.vue?vue&type=script&lang=js"
import style0 from "./ReviewsPagination.vue?vue&type=style&index=0&id=eaee21a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaee21a4",
  null
  
)

export default component.exports